export const itemsPerPageDefault = 20;

export const currentPageDefault = 1;
